import React from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';

const RowActions = ({ onEdit, onDelete, children, after, className = 'flex space-x-4 items-center' }) => (
  <div className={className}>
    {onEdit && (
      <FaPen
        title="Edit"
        onClick={onEdit}
        className="cursor-pointer text-blue-500"
      />
    )}
    {children}
    {onDelete && (
      <FaTrash
        title="Delete"
        onClick={onDelete}
        className="cursor-pointer text-red-600"
      />
    )}
    {after}
  </div>
);

export default RowActions;
